import { Pagination, Box } from "@mui/material";

const PaginationComponent = ({ data, onChange }) => {
    const totalPages = Math.ceil(data.count / data.page_size);

    if (totalPages <= 1) return null; // Oculta se só tiver uma página

    return (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Pagination
                count={totalPages}
                page={data.page}
                onChange={(_, value) => onChange(value)}
                shape="rounded"
                color="primary"
            />
        </Box>
    );
};

export default PaginationComponent;
